// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* Based on the "Color Tokens" view -------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const colors: Styleguide["colors"] = {
    primary: {
        main: "#c90017", // Primary -> Main
        contrast: "#ffffff", // None, look at primary button text color
        light: "#ea001b", // Primary -> Light
        dark: "#990400", // Primary -> Dark
    },
    secondary: {
        main: "#333333", // Secondary -> Main
        contrast: "#ffffff", // None, look at secondary button text color
        light: "#444444", // Secondary -> Light
        dark: "#000000", // Secondary -> Dark
    },
    tertiary: {
        main: "#262933", // Tertiary -> Main
        contrast: "#ffffff", // None, look at tertiary button text color
        light: "#5d5f66", // Tertiary -> Light
        dark: "#14151c", // Tertiary -> Dark
    },
    common: {
        border: "#e1e2e7", // Border -> Border
        borderLight: "#f8f8f8", // Gray Shades -> Light
        borderDark: "#52535a", // Gray Shades -> Main
        accent: "#f8f8f8", // Gray Shades -> Light
        accentContrast: "#333333", // Text Color -> Main
        accentContrastLight: "#52535a", // Gray Shades -> Main
        background: "#ffffff", // None, look at website background color
        backgroundContrast: "#333333", // Text Color -> Main
        disabled: "#f8f8f8", // Gray Shades -> Light
        disabledDark: "#d8d8df", // Gray Shades -> Mid
        // Store Custom Code
        dark: "#000000",
    },
    text: {
        main: "#333333", // Text Color -> Main
        accent: "#7e7f86", // Text Color -> Accent
        disabled: "#989aa9", // Text Color -> Semi
        link: "#c90017", // Primary -> Main
        linkHover: "#990400", // Primary -> Dark
        linkAlt: "#333333", // Text Color -> Main
        linkAltHover: "#c90017", // Primary -> Main
        input: "#333333", // Text Color -> Main
    },
    success: {
        main: "#0f7b5c", // Alerts/Contrast -> Success
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Success" token
        light: "#e4f5f4", // Alerts/Light -> Success
    },
    warning: {
        main: "#a45e28", // Alerts/Contrast -> Warning
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Warning" token
        light: "#fff5e9", // Alerts/Light -> Warning
    },
    danger: {
        main: "#cb2045", // Alerts/Contrast -> Error
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Error" token
        light: "#f5e8ea", // Alerts/Light -> Error
    },
    info: {
        main: "#1676b1", // Alerts/Contrast -> Info
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Info" token
        light: "#f0faff", // Alerts/Light -> Info
    },
    neutral: {
        main: "#616161", // None
        contrast: "#ffffff", // None
        light: "#e0e0e0", // None
    },
    invert: {
        main: "#ffffff", // None
        contrast: "#c90017", // Primary -> Main
        hover: "#990400", // Primary -> Dark
        dark: "#ececec", // None
    },
    placeholder: {
        main: "#7e7f86", // Text Color -> Accent
        disabled: "#d8d8df", // Gray Shades -> Mid
    },
    button: {
        disabled: {
            main: "#d8d8df", // Gray Shades -> Mid
            contrast: "#ffffff", // Black & White -> White
        },
    },
    header: {
        main: "#ffffff", // None, look at header background color
        contrast: "#333333", // Text Color -> Main
        hover: "#ffffff", // Primary -> Dark
        accent: "#c90017", // Primary -> Main
        accentHover: "#990400", // Primary -> Dark
        accentContrast: "#ffffff", // None, should match "primary.contrast"
    },
    menu: {
        mainNavigation: {
            main: "#ffffff", // None, look at main navigation background color
            contrast: "#333333", // Text Color -> Main
            hover: "#c90017", // Primary -> Main
            underline: "#ffffff", // Primary -> Main
            accent: "#c90017", // Primary -> Main
            accentContrast: "#ffffff", // None, should match "primary.contrast"
            accentHover: "#990400", // Primary -> Main
            separator: "#e1e2e7", // Border -> Border
            border: "#d8d8df", // Border -> Border
            // Store Custom Code
            invert: "#000000",
        },
        secondaryNavigation: {
            main: "#c90017", // Primary -> Dark
            contrast: "#ffffff", // None, should match "primary.contrast"
            hover: "#ffffff", // None, should match "primary.contrast"
            // Store Custom Code
            accentHover: "#333333", // Primary -> Dark
        },
        megaMenuWithTabs: {
            tabsBackground: "#f8f8f8", // Gray Shades -> Light
            tabsBackgroundHover: "#ffffff",
        },
    },
    footer: {
        main: "#f8f8f8", // Gray Shades -> Light
        contrast: "#333333", // Text Color -> Main
        alt: "#000000", // Primary -> Dark
        altContrast: "#ffffff", // None, should match "primary.contrast"
    },
    swatch: {
        main: "#e1e2e7", // Border -> Border
        contrast: "#333333", // Text Color -> Main
        hover: "#c90017", // Primary -> Main
        selected: "#c90017", // Primary -> Main
        selectedHover: "#990400", // Primary -> Dark
    },
};

export default colors;
